// extracted by mini-css-extract-plugin
module.exports = {"kefu":"SideKefu_kefu__2gZbE","show":"SideKefu_show__2CpVX"};